require('./RAPortfolioDistributionView.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');

// @commons
const RACover = require('../../components/commons/RACover/RACover');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKLink } = require('commonsComponents/OKLink');

// @components
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');
const RAPortfolioDonut = require('../../components/RAPortfolioDonut/RAPortfolioDonut');
const RAPortfolioCompositionTable = require('../../components/RAPortfolioCompositionTable/RAPortfolioCompositionTable');
const FeatureTogglingRender = require('components/conditionalRender/featureTogglingRender');

// @actions
const portfolioDistributionActions = require('../../actions/RAPortfolioDistribution');
const raHireManagementPlanActions = require('../../actions/RAHireManagementPlan');
const raManagementPlanActions = require('../../actions/RAManagementPlan');

// @utilities
const { FormattedText, formatText } = require('core/i18n').i18n;
const { base64ToBlob } = require('utilities/APIRequestHelper');
const { scrollToTop } = require('commonsUtilities/scrollUtils');
const { recordLink } = require('utilities/tagging');

// @constants
const { MYPROFILE_BROKER_URL } = require('constants/index');
const {
    TIME_HORIZON_CHECK_ERROR,
    MYPROFILE_ROBO_SETGOAL,
    HIRE_OBJECTIVE_PLAN_URL,
} = require('../../raConstants/index');
const {
    ESG_PRODUCT,
    ROBO_PRECONTRACT,
} = require('constants/flagBasedFeatures');

class RAPortfolioDistributionView extends React.Component {
    constructor(props) {
        super(props);

        this.handleBackClick = this.handleBackClick.bind(this);
        this.handleHireClick = this.handleHireClick.bind(this);
        this.handleManagementPDFClick = this.handleManagementPDFClick.bind(
            this,
        );
        this.buildHireButton = this.buildHireButton.bind(this);
        this.buildButtons = this.buildButtons.bind(this);
        this.handleHireClick = this.handleHireClick.bind(this);
    }

    componentDidMount() {
        this.props.setInitialContributionAmount(
            this.props.match.params.portfolioAmount,
        );
    }

    handleHireClick() {
        this.props.saveSimulation(this.props.history, true);
        recordLink('interaccion en detalle cartera', 'contratar');
        this.props.history.push(HIRE_OBJECTIVE_PLAN_URL);
    }

    getBreadcrumb() {
        return [
            {
                text: formatText('raPortfolioDistribution-investments'),
                url: MYPROFILE_BROKER_URL,
            },
            {
                text: formatText('raPortfolioDistribution-myGoalsBreadcrumb'),
                url: MYPROFILE_ROBO_SETGOAL,
            },
            {
                text: formatText(
                    'raPortfolioDistribution-investmentsPlanBreadcrumb',
                ),
            },
        ];
    }

    handleManagementPDFClick() {
        const documentContent = this.props.immHireManagementPlan.get('pdfLink');
        const url = URL.createObjectURL(
            new Blob([base64ToBlob(documentContent)], {
                type: 'application/pdf',
            }),
        );
        window.open(url, '_blank');
        recordLink('interaccion en detalle cartera', 'ver contrato');
    }

    handleBackClick() {
        scrollToTop();

        recordLink('interaccion en detalle cartera', 'volver');
        this.props.history.goBack();
    }

    shouldDisableHireButton(
        objectiveAmount,
        initialContributionAmount,
        selectedStrategy,
        immTimeHorizonCheck,
        immCustomPlanByObjective,
    ) {
        return (
            !objectiveAmount ||
            !initialContributionAmount ||
            !selectedStrategy ||
            immTimeHorizonCheck.get('status') === TIME_HORIZON_CHECK_ERROR ||
            immCustomPlanByObjective.get('errorAmountMin') ||
            immCustomPlanByObjective.get('errorInitialMin') ||
            immCustomPlanByObjective.get('errorPeriodicityMin')
        );
    }

    buildHireButton(renderHireButton) {
        let hireButtonComponent;

        if (
            renderHireButton &&
            (renderHireButton === '1' || renderHireButton === '2')
        ) {
            const {
                immTimeHorizonCheck,
                immCustomPlanByObjective,
                immSuitabilityTest,
            } = this.props;
            const maxInvestmentProfile = immSuitabilityTest.getIn(
                ['results', 0, 'maxTypeOfProduct'],
                0,
            );
            const objectiveAmount = immCustomPlanByObjective.get(
                'objectiveAmount',
            );
            const candidateStrategy = immCustomPlanByObjective.get(
                'selectedStrategy',
            );
            const selectedStrategy =
                maxInvestmentProfile >= candidateStrategy
                    ? candidateStrategy
                    : null;
            const initialContributionAmount = immCustomPlanByObjective.get(
                'initialContributionAmount',
            );
            const disabled = this.shouldDisableHireButton(
                objectiveAmount,
                initialContributionAmount,
                selectedStrategy,
                immTimeHorizonCheck,
                immCustomPlanByObjective,
            );
            hireButtonComponent = (
                <div className="ra-portfolio-distribution-view__buttons--right">
                    <OKButton
                        to={HIRE_OBJECTIVE_PLAN_URL}
                        onClick={this.handleHireClick}
                        disabled={disabled}
                    >
                        <FormattedText value="raManagementPlan-ctaButton" />
                    </OKButton>
                </div>
            );
        }
        return hireButtonComponent;
    }

    buildButtons() {
        return (
            <div className="ra-portfolio-distribution-view__buttons">
                <div className="ra-portfolio-distribution-view__buttons--left">
                    <OKButton
                        modifier="ghost"
                        leftIcon="icon-anterior"
                        inverse="true"
                        onClick={this.handleBackClick}
                    >
                        <FormattedText value="raPortfolioDistribution-goBack" />
                    </OKButton>
                </div>
                {this.buildHireButton(this.props.match.params.renderHireButton)}
            </div>
        );
    }

    render() {
        const uriParams = this.props.match.params.portfolioId;
        const {
            immManagementPlan,
            immPortfolioDistribution,
            immGlobalVariables,
            immProfile,
            flagBasedFeatures,
        } = this.props;
        const investProfileValue = this.props.match.params.portfolioId;
        const breadcrumb = this.getBreadcrumb();
        const buildHireButton = this.buildHireButton(
            this.props.match.params.renderHireButton,
        );
        let donutContent;
        let tableContent;
        const immAssetAllocations = immPortfolioDistribution.getIn(
            ['portfolio', investProfileValue.toString(), 'assetAllocations'],
            [],
        );
        const buttonDisabled = !!immManagementPlan.get('error');
        const precontractURL =
            immGlobalVariables.getIn([
                'parameters',
                'contratos',
                'precontractuales_robo',
            ]) || '';
        const originCountry = immProfile.get('originCountry');

        const moreInfoLinkManagement = [
            ...(flagBasedFeatures.get(ROBO_PRECONTRACT) ? (
                <OKLink
                    modifier="emphasize"
                    key={0}
                    to={precontractURL}
                    target="_blank"
                >
                    <FormattedText value="raManagementPlan-moreInfoText4Link" />
                </OKLink>
            ) : (
                []
            )),
            <OKLink
                modifier="emphasize"
                key={1}
                onClick={() => this.handleManagementPDFClick()}
            >
                <FormattedText value="raManagementPlan-moreInfoText3Link" />
            </OKLink>,
        ];

        if (immPortfolioDistribution.get('isFetching')) {
            donutContent = <LoadingSection />;
            tableContent = <LoadingSection />;
        } else {
            if (immAssetAllocations) {
                donutContent = (
                    <RAPortfolioDonut
                        immAssetAllocations={immAssetAllocations}
                    />
                );
                tableContent = (
                    <RAPortfolioCompositionTable
                        immAssetAllocations={immAssetAllocations}
                        immManagementPlan={immManagementPlan}
                        flagBasedFeatures={flagBasedFeatures}
                    />
                );
            }
        }
        const headerTitles = {
            1: formatText('raPortfolioDistribution-strategy1'),
            2: formatText('raPortfolioDistribution-strategy2'),
            3: formatText('raPortfolioDistribution-strategy3'),
            4: formatText('raPortfolioDistribution-strategy4'),
            5: formatText('raPortfolioDistribution-strategy5'),
        };
        const headerIcons = {
            1: 'icon-KualaLumpur-small',
            2: 'icon-shangai-small',
            3: 'icon-taipei-small', // @TODO: test it when ezequiel upload icon-fonts
            4: 'icon-NewYork-small',
            5: 'icon-dubai-small',
        };
        const iconTitleClass = `ra-portfolio-distribution-view__icon-title ${headerIcons[uriParams]}`;
        const iconTitle = <i className={iconTitleClass} />;
        const rightSectionButtons = this.buildButtons();
        return (
            <div className="ra-portfolio-distribution-view grid-view">
                <div className="container-fluid">
                    <div className="row">
                        <RACover
                            breadcrumb={breadcrumb}
                            iconTitle={iconTitle}
                            title={headerTitles[uriParams]}
                            showHelp={true}
                            helpContent={rightSectionButtons}
                        />
                    </div>
                </div>

                <div className="row ra-portfolio-distribution-view__container--salmon">
                    <div className="grid-view__body">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="ra-portfolio-distribution-view__section-donut-tabs">
                                        <h3 className="ra-portfolio-distribution-view__section-title">
                                            <FormattedText value="raManagementPlanView-distributionTitle" />
                                        </h3>
                                        <FormattedText
                                            value="raManagementPlanView-distributionInfo"
                                            className="ra-portfolio-distribution-view__section-info"
                                        />
                                        {donutContent}
                                    </div>
                                    <div className="ra-portfolio-distribution-view__section-table ra-portfolio-distribution-view__container--white">
                                        <h3 className="ra-portfolio-distribution-view__section-title">
                                            <FormattedText value="raManagementPlanView-distributionDetailsTitle" />
                                        </h3>
                                        <FeatureTogglingRender
                                            notAllowedProductKey={ESG_PRODUCT}
                                        >
                                            <div className="ra-portfolio-distribution-view__section-esg-tag">
                                                <i className="ra-portfolio-distribution-view__section-esg-icon" />
                                                <FormattedText value="raPortfolioDistribution-raPortfolioDistribution_esgTag" />
                                            </div>
                                        </FeatureTogglingRender>
                                        <div className="ra-portfolio-distribution-view__table-container">
                                            {tableContent}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row ra-portfolio-distribution-view__container--salmon">
                    <div className="grid-view__body">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-md-12 ra-portfolio-distribution-view__footer">
                                    <div className="ra-portfolio-distribution-view__more-info-link">
                                        <p>
                                            <FormattedTextWithComponents
                                                value={`raManagementPlan-moreInfoText3_${originCountry}`}
                                                injectedComponents={
                                                    moreInfoLinkManagement
                                                }
                                            />
                                        </p>
                                    </div>
                                    <div className="ra-portfolio-distribution-view__buttons">
                                        <div className="ra-portfolio-distribution-view__buttons--left">
                                            <OKButton
                                                onClick={this.handleBackClick}
                                                disabled={buttonDisabled}
                                                modifier="ghost"
                                                leftIcon="icon-anterior"
                                            >
                                                <FormattedText value="raPortfolioDistribution-goBack" />
                                            </OKButton>
                                        </div>
                                        {buildHireButton}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

RAPortfolioDistributionView.propTypes = {
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    immManagementPlan: PropTypes.object.isRequired,
    immPortfolioDistribution: PropTypes.object.isRequired,
    requestPortfolioDistribution: PropTypes.func.isRequired,
    getPDFContract: PropTypes.func.isRequired,
    immHireManagementPlan: PropTypes.object.isRequired,
    saveSimulation: PropTypes.func.isRequired,
    setInitialContributionAmount: PropTypes.func.isRequired,
    immCustomPlanByObjective: PropTypes.object.isRequired,
    immSuitabilityTest: PropTypes.object.isRequired,
    immTimeHorizonCheck: PropTypes.object.isRequired,
    immGlobalVariables: PropTypes.object.isRequired,
    immProfile: PropTypes.object,
    flagBasedFeatures: PropTypes.object.isRequired,
};

module.exports = connect(
    state => ({
        immManagementPlan: state.raManagementPlan,
        immPortfolioDistribution: state.raPortfolioDistribution,
        immProfile: state.profile,
        immExpectedProfitability: state.raExpectedProfitability,
        immHireManagementPlan: state.raHireManagementPlan,
        immCustomPlanByObjective: state.raCustomPlanByObjective,
        immSuitabilityTest: state.raSuitabilityTest,
        immTimeHorizonCheck: state.raTimeHorizonCheck,
        immGlobalVariables: state.globalVariables.get('variables'),
        flagBasedFeatures: state.flagBasedFeatures,
    }),
    {
        requestPortfolioDistribution:
            portfolioDistributionActions.requestPortfolioDistribution,
        getPDFContract: raHireManagementPlanActions.getPDFContract,
        saveSimulation: raManagementPlanActions.saveSimulation,
        setInitialContributionAmount:
            raManagementPlanActions.setInitialContributionAmount,
    },
)(withRouter(RAPortfolioDistributionView));
